import React, { FunctionComponent } from 'react';
import { useRecoilValue } from 'recoil';
import { useStyletron } from 'styletron-react';
import { Notification } from 'baseui/notification';
import { appNotifications } from './AppNotificationsState';

interface AppNotificationsProps {}

export const AppNotifications: FunctionComponent<AppNotificationsProps> = () => {
    const notifications = useRecoilValue(appNotifications);
    const [css] = useStyletron();

    const containerCss = css({
        position: 'fixed',
        top: '80px',
        right: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        justifyItems: 'flex-end',
    });

    return (
        <div className={containerCss}>
            {notifications.map((notification) => (
                <Notification
                    key={notification.id}
                    kind={notification.kind}
                    closeable={notification.closeable}
                    overrides={{
                        Body: {
                            style: {
                                boxShadow: '0px 0px 10px 1px rgba(0,0,0,0.4)',
                            },
                        },
                    }}
                >
                    {notification.text}
                </Notification>
            ))}
        </div>
    );
};
